import { render, staticRenderFns } from "./CommonCase.vue?vue&type=template&id=a16eb9ce&scoped=true&"
import script from "./CommonCase.vue?vue&type=script&lang=js&"
export * from "./CommonCase.vue?vue&type=script&lang=js&"
import style0 from "./CommonCase.vue?vue&type=style&index=0&id=a16eb9ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a16eb9ce",
  null
  
)

export default component.exports